import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { Video } from './video.model';

const axios = useAxios();

export interface VideoService {
  Fetch: () => Promise<AxiosResponse<Video[]>>;
  Find: (id: number) => Promise<AxiosResponse<Video>>;
}

const Fetch = (): Promise<AxiosResponse<Video[]>> =>
  axios.Get<Video[]>('api/videos');

const Find = (id: number): Promise<AxiosResponse<Video>> =>
  axios.Get<Video>(`/api/videos/${id}`);

export default { Fetch, Find } as VideoService;
